module.exports = __webpack_public_path__ + "static/media/scrollToTop.a0aaa71c.svg";